import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import SupervisiBdrsSvc, {
  SupervisiBdrsListFilter,
} from "@/services/SupervisiBdrsService";
import { SupervisiBdrs } from "@/types/SupervisiBdrs";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "supervisi-bdrs",
})
class SupervisiBdrsModule extends VuexModule {
  items: SupervisiBdrs[] = [];
  currentItem: SupervisiBdrs | null = null;
  loading = false;
  meta: {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
  } | null = null;

  @Mutation SET_ITEMS(val: SupervisiBdrs[]) {
    this.items = val || [];
  }

  @Mutation SET_CURRENT_ITEM(val: SupervisiBdrs | null) {
    this.currentItem = val;
  }

  @Mutation SET_META(val: any) {
    this.meta = val || null;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchList(params: SupervisiBdrsListFilter = {}) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiBdrsSvc.list(params);
      this.SET_ITEMS(dt.data.data || []);
      this.SET_META(dt.data.meta || null);
    } catch {
      this.SET_ITEMS([]);
      this.SET_META(null);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiBdrsSvc.find(id);
      this.SET_CURRENT_ITEM(dt.data.data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
    this.SET_META(null);
  }
}

export const storeSupervisiBdrs = getModule(SupervisiBdrsModule);
